import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

function Hero() {
  const bgRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (bgRef.current) {
        const scrolled = window.scrollY;
        bgRef.current.style.transform = `scale(1.05) translateY(${scrolled * 0.3}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hero" id="top">
      <div className="hero-bg" ref={bgRef} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/hero-bg.png)` }}></div>
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <img src="/assets/NC_New_LOGO.png" alt="Nexus Concordat" className="hero-logo" />

        <span className="hero-label">
          Nexus Concordat &middot; Hamilton, Alabama
        </span>

        <h1 className="hero-title">
          When Clinical<br />
          AI Demands<br />
          <span className="gold">ISO 17511:2020<br />Traceability</span>
        </h1>

        <p className="hero-sub">
          <strong>The language model is the instrument.</strong><br />
          It must be vetted at the substrate level.
        </p>

        <p className="hero-meta">
          <strong>Four</strong> U.S. provisional patent applications
        </p>

        <div className="hero-actions">
          <Link to="/portfolio" className="btn-gold">How It Works</Link>
          <Link to="/contact" className="btn-outline">Get In Touch</Link>
        </div>
      </div>

      <div className="scroll-hint">
        <span>Scroll</span>
        <div className="scroll-line">
          <div className="scroll-fill"></div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
